/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm,formValueSelector,submit,change } from 'redux-form';
import queryString from 'query-string';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import DocTitle from './common/DocTitle';
import DocDecisionAndActionSubmit from './DocDecisionAndActionSubmit';
import DocFormMemberEmployee from './DocFormMemberEmployee';
import DocFormApplicant from './DocFormApplicant';
import DocFormApplication from './DocFormApplication';
import DocFormPhysician from './DocFormPhysician';
import DocFormQuestions from './DocFormQuestions';
import DocFormAdditionalQuestions from './DocFormAdditionalQuestions';
import DocFormSubmitButton from './DocFormSubmitButton';
import PanelSpace from './common/PanelSpace'
import ContentRowSpace from './common/ContentRowSpace'

import collect from 'collect.js'

import {validate,isAnyFormErrors} from './common/validate';
import * as actions from '../../redux/gorgon/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import * as actionTypes from '../../redux/gorgon/actionTypes'

import type { DocDataExtractionForm$PropsType } from './flowTypes'
import type { ReducerState } from '../../redux/gorgon/flowTypes'
import { transformDataToEditMedicalHistoryQuestions } from '../../redux/gorgon/editFormData'

import ExpandPanelContainer from './common/ExpandPanelContainer'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const styles = ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: 15,
        fontWeight: 500
    },
    headingError: {
        fontSize: 15,
        fontWeight: 700,
        color: 'red'
    }
})

class DocDataExtractionForm extends React.Component<DocDataExtractionForm$PropsType> {
    
    componentDidMount(){
        this.refreshEditData()
    }

    refreshEditData(){
        const location:Location = (this.props.location:any)
        const query = queryString.parse(location.search);
        if (query.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.gorgon,query.jwt,query.taskAcceptedInfoId)
        }
    }

    componentDidUpdate(prevProps){
        const gorgon = (prevProps.gorgon:any)
        const formData = gorgon.formData
        const nextGorgon = (this.props.gorgon:any)
        const nextFormData = nextGorgon.formData
        const formNum = formData['formNum']?formData['formNum']:''
        
        if (nextGorgon.formNumPopulated && formData !== nextFormData && formNum !== nextFormData['formNum']){
            const collection=collect(gorgon.forms)
            const gorgonForm=collection.firstWhere('form_num',nextFormData['formNum'])
            if (gorgonForm){
                const latestGorgon = (this.props.gorgon:any)
                const formData = (latestGorgon.formData:any)
                transformDataToEditMedicalHistoryQuestions((latestGorgon.formData:any),this.props.changeFieldValue)
            }
        }
    }

    render(){
        const { classes,handleSubmit,pristine,submitting,invalid,isOverrideFormNum } = this.props;
        const gorgon:ReducerState = (this.props.gorgon:any) 
        const location:Location = (this.props.location:any)
        const query = queryString.parse(location.search);
        
        if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
            return (
                <div className="container">
                    <ContentRowSpace />

                    <div className='row'>
                        <DocTitle />
                    </div>    
                    <div className="row">
                        <div className="alert alert-danger" role="alert">
                          ERROR! Missing Parameters!
                        </div>      
                    </div>    
                </div>
            )
        }
        const formPanels = gorgon.formExpandedPanels;
        const formError = gorgon.formError;
        const error = gorgon.error
        const empMemInfoFieldsError = isAnyFormErrors(formError,actionTypes.GORGON_PANEL_EMP_MEM_INFO,this.props)
        const applicantFieldsError = isAnyFormErrors(formError,actionTypes.GORGON_PANEL_APPLICANT_INFO,this.props)
        const addQuestionFieldsError = isAnyFormErrors(formError,actionTypes.GORGON_PANEL_ADDITIONAL_QUESTIONS,this.props)
        const reviewQuestionFieldsError = isAnyFormErrors(formError,actionTypes.GORGON_PANEL_REVIEW_QUESTIONS,this.props)
        const isPROD = query.isPROD?query.isPROD:false

        return (
            <div className="container">
                <ContentRowSpace />
                <div className='row'>
                    <DocTitle />
                </div>  
                <div className="row">
                    <div className="col-sm">
                        <a href={'https://docs.google.com/document/d/e/2PACX-1vTbZgfsHn31BN4JJrVbnkDOpS4jmbI9t7HHv0eZLtiacShuoJxYtGuJmX-nNpLuBj_zr0m7wuWTh_XA/pub?embedded=true'} target='_blank' >Instructions</a>
                        &nbsp;&nbsp;&nbsp;
                        <a href={query.docUrl} target='_blank' >PDF Link</a>
                    </div>
                </div>  
                <ContentRowSpace />
                {error?(
                    <div className="row" key={'error1'}>
                        <div className="col-sm">
                            <div className="alert alert-danger" role="alert">
                            {error}
                            </div>      
                        </div>
                    </div>  
                ):null}
                <form onSubmit={handleSubmit} >
                <div className="row">
                    <div className="col-sm">
                        <DocDecisionAndActionSubmit 
                        jwt={query.jwt} pristine={pristine} 
                        submitting={submitting} submitReduxForm={this.props.submitReduxForm} 
                        invalid={invalid} isOverrideFormNum={isOverrideFormNum}
                        changeFieldValue={this.props.changeFieldValue}  
                        isPROD={isPROD}
                        />
                    </div>
                </div>    
                <PanelSpace />
                <div className="row">
                    <div className="col-sm">
                        <div style={styles.root}>
                            <ExpansionPanel defaultExpanded={true}>
                                <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                                   <Typography style={styles.heading} >PDF Content</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <div className="embed-responsive embed-responsive-1by1" style={{height: '100%'}}>
                                        <iframe className="embed-responsive-item" src={query.docUrl}></iframe>
                                    </div>
                                </ExpansionPanelDetails>    
                            </ExpansionPanel>
                        </div>
                    </div>
                </div>
                <PanelSpace />
                
                <ExpandPanelContainer
                    title={'A. Member/Employee Information'} elementId={'Section_A_MemOrEmp_Info'}
                    actionType={actionTypes.GORGON_PANEL_EMP_MEM_INFO} formPanels={formPanels}
                    disabled={gorgon.formQuestions&&gorgon.formQuestions.length>0?false:true} 
                    fieldError={empMemInfoFieldsError}
                >
                    <DocFormMemberEmployee 
                            isOverrideMemEmpCheckWhoIsApply={this.props.isOverrideMemEmpCheckWhoIsApply} 
                            isOverrideMemEmpFirstNameNotFound={this.props.isOverrideMemEmpFirstNameNotFound}
                            isOverrideMemEmpLastNameNotFound={this.props.isOverrideMemEmpLastNameNotFound}/>
                </ExpandPanelContainer>                
    
                <ExpandPanelContainer
                    title={'B. Applicant Information'} elementId={'Section_B_Applicant_Info'}
                    actionType={actionTypes.GORGON_PANEL_APPLICANT_INFO} formPanels={formPanels}
                    disabled={gorgon.formQuestions&&gorgon.formQuestions.length>0?false:true} 
                    fieldError={applicantFieldsError}
                >
                    <DocFormApplicant 
                            isOverrideAppFirstNameNotFound={this.props.isOverrideAppFirstNameNotFound}
                            isOverrideAppLastNameNotFound={this.props.isOverrideAppLastNameNotFound} 
                            isOverrideAppStreetAddrLine1NotFound={this.props.isOverrideAppStreetAddrLine1NotFound} 
                            isOverrideAppCityNotFound={this.props.isOverrideAppCityNotFound}
                            isOverrideAppStateNotFound={this.props.isOverrideAppStateNotFound}
                            isOverrideAppZipNotFound={this.props.isOverrideAppZipNotFound}
                            isOverrideAppSexNotFound={this.props.isOverrideAppSexNotFound}
                            isOverrideAppWorkPhoneNumNotFound={this.props.isOverrideAppWorkPhoneNumNotFound}
                            isOverrideAppHomePhoneNumNotFound={this.props.isOverrideAppHomePhoneNumNotFound}
                            changeFieldValue={this.props.changeFieldValue}
                            memEmpFirstName={this.props.memEmpFirstName}
                            memEmpMiddleName={this.props.memEmpMiddleName}
                            memEmpLastName={this.props.memEmpLastName}
                            memEmpBirthdate={this.props.memEmpBirthdate}
                            memEmpNameSuffix={this.props.memEmpNameSuffix}
                            memEmpSSN={this.props.memEmpSSN}
                            isOverrideAppCountry={this.props.isOverrideAppCountry}
                            isOverrideAppBirthplaceCountry={this.props.isOverrideAppBirthplaceCountry}
                    />
                </ExpandPanelContainer>
 
                <ExpandPanelContainer
                    title={'C. Application Information'} elementId={'Section_C_App_Info'} 
                    actionType={actionTypes.GORGON_PANEL_APPLICATION_INFO} formPanels={formPanels}
                    disabled={gorgon.formQuestions&&gorgon.formQuestions.length>0?false:true}
                >
                    <DocFormApplication changeFieldValue={this.props.changeFieldValue} />
                </ExpandPanelContainer>
                
                <ExpandPanelContainer
                    title={'D. Physician Information'} elementId={'Section_D_Physician_Info'}
                    actionType={actionTypes.GORGON_PANEL_PHYSICIAN_INFO} formPanels={formPanels} 
                    disabled={gorgon.formQuestions&&gorgon.formQuestions.length>0?false:true}
                >
                    <DocFormPhysician />
                </ExpandPanelContainer>

                <ExpandPanelContainer 
                    title={'E. Medical History Statement Questions'.concat(" [").concat(isPROD?"Production":"Testing").concat("]")} elementId={'Section_E_Medical_History_Statement'}
                    actionType={actionTypes.GORGON_PANEL_FORM_QUESTIONS} formPanels={formPanels} 
                    disabled={gorgon.formQuestions&&gorgon.formQuestions.length>0?false:true}
                >
                    <DocFormQuestions jwt={query.jwt} changeFieldValue={this.props.changeFieldValue}/>
                </ExpandPanelContainer>

                <ExpandPanelContainer 
                    title={'F. Additional Questions'} fieldError={addQuestionFieldsError}
                    elementId={'Section_F_Additional_Questions'} formPanels={formPanels} 
                    actionType={actionTypes.GORGON_PANEL_ADDITIONAL_QUESTIONS} 
                    disabled={gorgon.formQuestions&&gorgon.formQuestions.length>0?false:true}
                    >
                    <DocFormAdditionalQuestions 
                        isOverrideApplicantSignatureDateNotFound={this.props.isOverrideApplicantSignatureDateNotFound} 
                        changeFieldValue={this.props.changeFieldValue} 
                    />
                </ExpandPanelContainer>    
                
                <ExpandPanelContainer 
                    title={'Final Review Before Submission'} elementId={'Review_Questions'} formPanels={formPanels} 
                    actionType={actionTypes.GORGON_PANEL_REVIEW_QUESTIONS}
                    visible={query.isVerifyMode?query.isVerifyMode:false}
                    fieldError={reviewQuestionFieldsError}
                >
                    <QualityReviewContainer 
                     elementId={'gorgonPanelReviewQuestion'} 
                     changeFieldValue={this.props.changeFieldValue} 
                     questions={(gorgon.reviewQuestions:any)} 
                    />
                </ExpandPanelContainer>    

                <div className='row'>
                    <div className="col-sm">
                        <DocFormSubmitButton pristine={pristine} submitting={submitting} invalid={invalid}  />
                    </div>    
                </div>    
                </form>
            </div>
        )
    }
}

const submitMethod = (values, dispatch, props) => {
    const query = queryString.parse(props.location.search);
    props.submitCloseActionDialog();
    
    props.docSubmission(query.jwt,query.taskAcceptedInfoId,values,props.gorgon.formQuestions,props.gorgon.formAppCoverages,props.gorgon.reviewQuestions);
}

const form='gorgonDocDataExtractionReduxForm';
let DocDataExtractionReduxForm = reduxForm({
    form: form,
    enableReinitialize: true,
    validate,
    onSubmit: submitMethod
})(DocDataExtractionForm)

const selector = formValueSelector(form)

const mapStateToProps:any = (state, ownProps) => {
    return {
        gorgon: state.gorgon,
        initialValues: state.gorgon.formData,
        actConfDialog: state.actConfDialog,
        isOverrideFormNum: selector(state, 'isOverrideFormNum'),
        isOverrideMemEmpCheckWhoIsApply: selector(state, 'isOverrideMemEmpCheckWhoIsApply'),
        isOverrideMemEmpFirstNameNotFound: selector(state, 'isOverrideMemEmpFirstNameNotFound'),
        isOverrideMemEmpLastNameNotFound: selector(state, 'isOverrideMemEmpLastNameNotFound'),
        isOverrideAppFirstNameNotFound: selector(state, 'isOverrideAppFirstNameNotFound'),
        isOverrideAppLastNameNotFound: selector(state, 'isOverrideAppLastNameNotFound'),
        isOverrideAppStreetAddrLine1NotFound: selector(state, 'isOverrideAppStreetAddrLine1NotFound'),
        isOverrideAppCityNotFound: selector(state, 'isOverrideAppCityNotFound'),
        isOverrideAppStateNotFound: selector(state, 'isOverrideAppStateNotFound'),
        isOverrideAppZipNotFound: selector(state, 'isOverrideAppZipNotFound'),
        isOverrideAppSexNotFound: selector(state, 'isOverrideAppSexNotFound'),
        isOverrideAppWorkPhoneNumNotFound: selector(state, 'isOverrideAppWorkPhoneNumNotFound'),
        isOverrideAppHomePhoneNumNotFound: selector(state, 'isOverrideAppHomePhoneNumNotFound'),
        isOverrideApplicantSignatureDateNotFound: selector(state, 'isOverrideApplicantSignatureDateNotFound'),
        memEmpFirstName: selector(state, 'memEmpFirstName'),
        memEmpMiddleName: selector(state, 'memEmpMiddleName'),
        memEmpLastName: selector(state, 'memEmpLastName'),
        memEmpBirthdate: selector(state, 'memEmpBirthdate'),
        memEmpNameSuffix: selector(state, 'memEmpNameSuffix'),
        memEmpSSN: selector(state, 'memEmpSSN'),
        isOverrideAppCountry: selector(state, 'isOverrideAppCountry'),
        isOverrideAppBirthplaceCountry: selector(state, 'isOverrideAppBirthplaceCountry'),
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
        changeFieldValue: (field, value)=> {
           dispatch(change(form, field, value))
        },
        submitReduxForm: ()=>{
           dispatch(submit(form))
        },
        docSubmission: (jwt,taskAcceptedInfoId,formData,formQuestions,formAppCoverages,reviewQuestions)=>{
            dispatch(actions.docSubmission(jwt,taskAcceptedInfoId,formData,formQuestions,formAppCoverages, reviewQuestions))
        },
        submitCloseActionDialog: ()=> {
            dispatch(actConfDlgActions.closeDialog())    
        },
        addFormExpandablePanel: (panel)=> {
            dispatch(actions.addFormExpandablePanel(panel))    
        },
        removeFormExpandablePanel: (panel)=> {
            dispatch(actions.removeFormExpandablePanel(panel))    
        },
        updateFormError: (error)=> {
            dispatch(actions.updateFormError(error))    
        },
        getTaskData: (gorgon,jwt,taskAcceptedInfoId)=>{
            dispatch(actions.getTaskData(gorgon,jwt,taskAcceptedInfoId))  
        },
        populateFormQuestionsList: (jwt,gorgonFormId,isPROD) => {
            dispatch(actions.populateFormQuestionsList(jwt,gorgonFormId,isPROD))  
        },
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(DocDataExtractionReduxForm);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocDataExtractionForm.js